import * as React from 'react'

import styled from '@emotion/styled'

import Icon from './Icon'
import Stack from './Stack'

const orderedIcons = ['numeral1', 'numeral2', 'numeral3'] as const

const ListItem = styled.li`
  color: ${props => (props.theme.darkMode ? props.theme.colors.secondaryLabel : props.theme.colors.label)};
  display: flex;
  font-size: 1.5rem;
`

const ListItemLabel = styled.span`
  ${props => props.theme.typography.bodyText};
  margin-left: 1rem;
  color: ${props => props.theme.colors.secondaryLabel};
  flex: 1;
`

const NumeralList = ({ items, space = '1rem' }: { items: React.ReactNode[]; space?: string }) => {
  return (
    <Stack as="ol" space={space}>
      {items.map((item, index) => {
        const icon = orderedIcons[index]
        return (
          <ListItem key={index} aria-hidden>
            <Icon name={icon} />
            <ListItemLabel>{item}</ListItemLabel>
          </ListItem>
        )
      })}
    </Stack>
  )
}

export default NumeralList
